import React from "react";
import {Drawer, Form, Button, Col, Row, Input, Select} from 'antd';
import {LoadDataAnyEndpoint, SubmitLogInformation} from "../../../api/fn";
import moment from "moment";
import {GetUserToken} from "../../../api/token";


const {Option} = Select;

const makeCol = (row, _this) => {
    let {handleChangeInput} = _this;
    if (row === null) {
        return null;
    }
    if (row.datatype === "list") {
        let options = [];
        for (let i in row.options) {
            const key = i;
            const val = i;
            options.push({
                key: key,
                val: val,
            })
        }
        return (
            <Col span={12}>
                <Form.Item
                    name={row.fieldname}
                    label={row.fieldname}
                    rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
                >
                    <Select
                        placeholder={"Please enter user " + row.fieldname}
                        onChange={(e) => handleChangeInput(e, row.fieldname)}
                    >
                        {options.map(rec => {
                            return (
                                <Option value={rec.key}>{rec.val}</Option>
                            )
                        })}
                    </Select>
                </Form.Item>
            </Col>
        )
    }
    return (
        <Col span={12}>
            <Form.Item
                name={row.fieldname}
                label={row.fieldname}
                rules={[{required: true, message: 'Please enter user ' + row.fieldname}]}
            >
                <Input
                    placeholder={"Please enter user " + row.fieldname}
                    onChange={(e) => handleChangeInput(e.target.value, row.fieldname)}
                />
            </Form.Item>
        </Col>
    )
}

export default class NewCommentDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            newEntry: {},
        }
    }

    handleChange = async (e, key) => {
        const value = e.value;
        this.setState({
            [key]: value,
        });

    }
    handleChangeInput = (val, key) => {
        let tmp = this.state;
        tmp.newEntry[key] = val;
        this.setState(tmp);
    }
    validateSubmitINput = () => {


        let attributes =[
            {fieldname:"subject",mandatory:true},
            {fieldname:"body",mandatory:true},
        ];
        let newEntry = this.state.newEntry;
        for (let i in attributes) {
            const row = attributes[i];
            if (row.mandatory) {
                if (typeof newEntry[row.fieldname] === "undefined") {
                    alert("Sorry " + row.fieldname + " is required field and can't be empty!");
                    return false;
                }
                if (newEntry[row.fieldname] === "") {
                    alert("Sorry " + row.fieldname + " is required field and can't be empty!");
                    return false;
                }
            }
        }
        return true;
    }

    onSubmit = async () => {
        if (!this.validateSubmitINput()) {
            return
        }
        let self = this;

        if (!window.confirm("Are you sure to submit this comment!")) {
            return
        }

        let {_this} = this.props;
        let {state} = _this;
        let data = state.ActionData;
        if (data === null) {
            return
        }
        if(typeof data.record==="undefined"){
            return
        }
        let org = data.record.org;
        let project = data.record.module;
        let ref = data.record.ref;
        let workDate = moment().format("YYYY-MM-DD");
        let userInfo = GetUserToken();
        let username = userInfo.Username;

        let o = {
            WorkDate :workDate,
            Project  :project,
            Action   :"comment",
            Category :"all",
            Ref      :ref,
            Subject  : this.state.newEntry.subject,
            Body     : this.state.newEntry.body,
            Username :username,
        };

        let hub = {...o}



        let post = {}
        post.AutoGenerate = false;
        post.HasUniqueKey = false;
        post.AutoGenerateField = "";
        post.Data = hub;
        post.Params = {}
        let endpoint = "/common/entity/Comments/insert"; // "/manager/entity/insert/extensions";

        console.log("onSubmit new Comments send 2 > ", post);

        await LoadDataAnyEndpoint(post, endpoint, "Data", this, async (dataOut) => {
            console.log("onSubmit new Comments response > ", dataOut);
            self.onClose();
            _this.setState({
                newEntry: {},
            });
            await SubmitLogInformation(org,project,"comment","all","all",data.record.ref,o,self)
            alert("Thank you record added!")

        });

    }

    getAttributes = () => {
        let ls = [];
        let {_this} = this.props;
        let {state} = _this;
        let data = state.ActionData;
        if (data === null) {
            return ls
        }
        if (typeof data.record === "undefined") {
            return ls
        }
        let org = data.record.org;
        let project = data.record.module;

        console.log("New Stage GetAtt> ", data);

        for (let i in state.Fields) {
            let row = state.Fields[i];
            if (row.org !== org) {
                continue
            }
            if (row.module !== project) {
                continue
            }
            if (row.category !== "stage") {
                continue
            }
            if (row.ref !== this.state.selectedStage) {
                continue
            }
            ls.push(row);
        }
        return ls

    }
    getTitle = () => {
        let {_this} = this.props;
        let {state} = _this;
        if (state.ActionData !== null) {
            return state.ActionData.name;
        }
        return "----"
    }
    onClose = () => {
        let {_this} = this.props;
        _this.setState({
            showActionComment: false,
            ActionData: true
        })
    }


    render() {
        let {_this} = this.props;
        let {handleChangeInput} = this;
        let {state} = _this;

        console.log("Comment drawer list> ",_this.state)

        return (
            <>
                <Drawer
                    title={"Create a new comment for :" + this.getTitle()}
                    width={720}
                    onClose={this.onClose}
                    visible={state.showActionComment}
                    bodyStyle={{paddingBottom: 80}}
                    footer={
                        <div
                            style={{
                                textAlign: 'right',
                            }}
                        >
                            <Button onClick={this.onClose} style={{marginRight: 8}}>
                                Cancel
                            </Button>
                            <Button onClick={this.onSubmit} type="primary">
                                Submit
                            </Button>
                        </div>
                    }
                >


                    <Form layout="vertical" hideRequiredMark>
                        <Row gutter={16} style={{marginTop: 20}}>
                            <Col span={24}>
                                <Form.Item
                                    name={"subject"}
                                    label={"Subject"}
                                    rules={[{required: true, message: 'Please enter  subject'}]}
                                >
                                    <Input
                                        placeholder={"Please enter subject "}
                                        onChange={(e) => handleChangeInput(e.target.value, "subject")}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Form.Item
                                    name={"body"}
                                    label={"Message"}
                                    rules={[{required: true, message: 'Please enter  message'}]}
                                >
                                    <Input.TextArea rows={4}
                                                    placeholder={"Please enter message "}
                                                    onChange={(e) => handleChangeInput(e.target.value, "body")}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                    </Form>
                </Drawer>
            </>
        )
    }
}
